export const ADMIN_ROLE_NAME = 'admin'
export const OBSERVER_ROLE_NAME = 'observer'
export const REVIEWER_ROLE_NAME = 'reviewer'
export const DEFAULT_ROLE_ID = 60
export const ADMIN_ROLE_ID = 40
